// Truth-safe brand impact strip. Discovery categories + Australia-wide positioning.
// Colour emphasis only — no unsupported numeric claims. Max one per page, pre-footer.
const ITEMS = [
  { label: "BANKS.", tone: "text-[#E50914]" },
  { label: "NON-BANKS.", tone: "text-white" },
  { label: "PRIVATE CAPITAL.", tone: "text-[#E50914]" },
  { label: "LOW DOC.", tone: "text-zinc-400" },
  { label: "ALT DOC.", tone: "text-white" },
  { label: "NO DOC.", tone: "text-[#E50914]" },
  { label: "AUSTRALIA-WIDE.", tone: "text-zinc-400" },
];

export default function FundingStrip({ className = "" }) {
  return (
    <div
      data-testid="funding-strip"
      className={`border-t border-zinc-900 py-8 px-6 ${className}`}
    >
      <div className="max-w-5xl mx-auto flex flex-wrap justify-center items-center gap-x-3 gap-y-2 font-bebas text-lg sm:text-xl md:text-2xl tracking-[0.06em] leading-none">
        {ITEMS.map((it, i) => (
          <span key={it.label} className="inline-flex items-center gap-x-3 whitespace-nowrap">
            {i > 0 && <span aria-hidden="true" className="text-zinc-700 font-outfit text-sm">·</span>}
            <span className={`${it.tone} font-bold`}>{it.label}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
